import { getCoreboundIconArt } from './coreboundIconArt';
const CoreboundIcon = ({ name, className = '' }) => {
  const art = getCoreboundIconArt(name);
  return (
    <svg
      className={`coreboundCustomIcon ${className}`}
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      data-icon={name}
      style={{ verticalAlign: '-0.16em', flexShrink: 0 }}
    >
      {(art.lines || []).map((points, index) => (
        <polyline
          key={index}
          points={points.map((point) => point.join(',')).join(' ')}
        />
      ))}
      {(art.circles || []).map(([cx, cy, r], index) => (
        <circle key={index} cx={cx} cy={cy} r={r} />
      ))}
    </svg>
  );
};
export default CoreboundIcon;
